export type EarnMetricsSource =
  | { type: "yield"; searchTerm: string }
  | { type: "taler"; vaultAddress: string }

export interface EarnVaultDef {
  tokenSymbol: string
  baseUnifiedAssetId: string
  metricsSource: EarnMetricsSource
  displayName: string
  shortName?: string
  description: string
  providerLabel: string
  position: "first-party" | "partner"
  minimumDepositUsdc?: number
  badge?: string
  displayFees: {
    label: string
    value: string
    description?: string
    badge?: string
  }[]
}

/** On-chain TLO vault on Ethereum — see Taler frontend data integration docs. */
export const TALER_TLO_VAULT_ADDRESS =
  "0x5fe86b1aDee4b18F6a8c55ea0bdBB55e2E445159"

export const TALER_API_URL = "https://api.taler.finance"

export const CURATED_EARN_VAULTS: EarnVaultDef[] = [
  {
    tokenSymbol: "gtUSDCp",
    baseUnifiedAssetId: "usdc",
    metricsSource: { type: "yield", searchTerm: "Gauntlet" },
    displayName: "Gauntlet USDC",
    shortName: "Gauntlet USDC",
    description: "Yield vault",
    providerLabel: "Gauntlet",
    position: "partner",
    minimumDepositUsdc: 25,
    displayFees: [
      { label: "Deposit fee", value: "Variable, up to 0.01%" },
      { label: "Withdrawal fee", value: "Fixed, 0.06%" },
      {
        label: "Performance fee",
        value: "7%",
        description: "of earned yield",
      },
    ],
  },
  {
    tokenSymbol: "TLO",
    baseUnifiedAssetId: "usdc",
    metricsSource: {
      type: "taler",
      vaultAddress: TALER_TLO_VAULT_ADDRESS,
    },
    displayName: "Taler USDC",
    shortName: "Taler USDC",
    description: "Yield vault",
    providerLabel: "Taler",
    position: "partner",
    minimumDepositUsdc: 10,
    badge: "Promo",
    displayFees: [
      { label: "Deposit fee", value: "Variable, up to 0.01%" },
      { label: "Withdrawal fee", value: "Fixed, 0.05%" },
      {
        label: "Performance fee",
        value: "0%",
        badge: "Promo",
        description: "through Oct 31, 2026. Future rate to be announced.",
      },
    ],
  },
]
